<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.keyword"
        placeholder="代币地址/用户地址/交易hash"
        style="width: 320px"
        class="filter-item"
        size="small"
        clearable
      />
      <el-button
        class="filter-item"
        size="small"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      size="large"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column label="ID" width="60" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="代币地址" min-width="110" align="center">
        <template slot-scope="scope">
          <span style="font-size: 12px;">{{ scope.row.mint }}</span>
        </template>
      </el-table-column>

      <el-table-column label="用户" min-width="110" align="center">
        <template slot-scope="scope">
          <span style="font-size: 12px;">{{ scope.row.user }}</span>
        </template>
      </el-table-column>

      <el-table-column label="类型" min-width="60" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.type == 1" type="primary">买入</el-tag>
          <el-tag v-else type="warning">卖出</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="SOL" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.sol_amount }}
        </template>
      </el-table-column>

      <el-table-column label="Token" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.token_amount }}
        </template>
      </el-table-column>

      <el-table-column label="交易hash" min-width="180" align="center">
        <template slot-scope="scope">
          <span style="font-size: 12px;">{{ scope.row.tx_hash }}</span>
        </template>
      </el-table-column>

      <el-table-column label="交易时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.trade_time | dateTimeFormat }}
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      request({
        url: "/api/admin/trade/list",
        method: "get",
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
.balance {
  font-size: 18px;
  font-weight: bold;
}
</style>
